import React, { useState } from 'react';
import { Button, Tooltip } from '@mui/material';
import UpdateIcon from '@mui/icons-material/Update';

import UpdateIndexDrawer from './UpdateIndexDrawer.tsx';

// Interface for source path objects (matching UpdateIndexDrawer)
interface SourcePath {
  path: string;
  status?: string;
}

// Interface for index details 
interface IndexDetails {
  id?: string;
  index_id?: string; 
  name?: string;
  type?: string;
  status?: string;
  source_path?: Array<SourcePath | string>;
}

// Props interface for the UpdateIndexButton component
interface UpdateIndexButtonProps {
  indexId?: string;
  indexName?: string;
  indexDetails?: IndexDetails;
  uploadId: string; // Upload ID from index creation - REQUIRED
  disabled?: boolean;
  variant?: "text" | "outlined" | "contained";
  size?: "small" | "medium" | "large";
  onUpdateComplete?: () => void;
}

export default function UpdateIndexButton({ 
  indexId, 
  indexName, 
  indexDetails,
  uploadId,
  disabled = false, 
  variant = "outlined",
  size = "medium",
  onUpdateComplete 
}: UpdateIndexButtonProps) {
  const [dialogOpen, setDialogOpen] = useState<boolean>(false);

  const handleDialogClose = (): void => {
    setDialogOpen(false);
    // Call callback if provided (useful for refreshing parent component)
    if (onUpdateComplete) {
      onUpdateComplete();
    }
  };

  const handleUpdateComplete = (): void => {
    // Handle update completion - refresh parent and close drawer
    handleDialogClose();
  };

  return (
    <>
      <Tooltip title="Add more files to this index">
        <Button
          variant={variant}
          size={size}
          startIcon={<UpdateIcon />}
          onClick={() => setDialogOpen(true)}
          disabled={disabled}
        >
          Update Collection
        </Button>
      </Tooltip>
      
      <UpdateIndexDrawer
        open={dialogOpen}
        onClose={handleDialogClose}
        indexId={indexDetails?.id || indexDetails?.index_id || indexId || ''}
        indexName={indexDetails?.name || indexName}
        indexDetails={indexDetails as any}
        uploadId={uploadId}
      />
    </>
  );
}